import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
// Hook
import useRadarCharts from '../../hooks/useRadarCharts';

function RadarDashboardVehicle({ plate }) {
  const { radarData, radarDataDriver } = useRadarCharts(plate);
  const chartRef = useRef(null);
  useEffect(() => {
    // Dispose old chart
    if (chartRef.current) {
      chartRef.current.dispose();
    }

    
    // Create chart instance
    const chart = am4core.create('chartRadar', am4charts.RadarChart);
    chartRef.current = chart;

    am4core.addLicense('ch-custom-attribution');
    am4core.options.autoDispose = true;

    // Set data
    chart.data = radarDataDriver;

    // Category axis
    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'type';

    // Make category axis tooltip transparent (invisible)
    categoryAxis.tooltip.background.fillOpacity = 0;
    categoryAxis.tooltip.background.strokeOpacity = 0;
    categoryAxis.tooltip.label.fillOpacity = 0;
    categoryAxis.tooltip.disabled = false;

    // Value axis
    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.axisFills.template.fill = chart.colors.getIndex(2);
    valueAxis.renderer.axisFills.template.fillOpacity = 0.05;

    // Flota series
    const series = chart.series.push(new am4charts.RadarSeries());
    series.dataFields.valueY = 'score';
    series.dataFields.categoryX = 'type';
    series.name = 'Flota';
    series.strokeWidth = 4;
    series.tooltipText = '{categoryX}: [bold]{valueY}[/]';
    series.tooltip.pointerOrientation = 'vertical';

    // Vehiculo series
    const series2 = chart.series.push(new am4charts.RadarSeries());
    series2.dataFields.valueY = 'score';
    series2.dataFields.categoryX = 'type';
    series2.name = 'Vehiculo';
    series2.strokeWidth = 3;
    series2.data = radarData;
    series2.tooltipText = '{categoryX}: [bold]{valueY}[/]';
    series2.tooltip.pointerOrientation = 'vertical';

    chart.cursor = new am4charts.RadarCursor();
    chart.cursorTooltipEnabled = false;
    // Legend
    chart.legend = new am4charts.Legend();

    // Export
    chart.exporting.menu = new am4core.ExportMenu();

    // Cleanup
    return () => {
      chart.dispose();
    };
  }, [radarData, radarDataDriver]);

  return (
    <div className="row no-gutters charDashboard2">
      <div className="col" id="chartRadar" />
    </div>
  );
}

RadarDashboardVehicle.propTypes = {
  plate: PropTypes.string.isRequired,
};

export default RadarDashboardVehicle;
